import { markRaw, Plugin } from 'vue'
import type { App } from 'vue'
import { createPinia } from 'pinia'
import { registerServices } from '@/plugins/RegisterModules'
import router from '@/router'

const initPinia: Plugin<[]> = {
  install(app: App) {
    const pinia = createPinia()
    pinia.use(({ store }) => {
      store.$router = markRaw(router)
    })
    pinia.use(({ store }) => {
      store.$services = registerServices
    })
    app.use(pinia)
  },
}

export default initPinia
